import { styles, variants, TrainTheme } from '../TrainStyles.css';
import { baseTheme } from './TrainBaseTheme.css';
import { multiVariantStyles } from './TrainVariants.css';

/*******************
 * Component Theme
 *******************/

const TrainRedwoodTheme: TrainTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TrainRedwoodTheme };
